<template>
  <form v-if="subscription.platformPlan != null">
    <md-button
      class="md-primary md-block"
      v-if="subscription.cancelledReason === 'no_card'"
    >
      No valid Credit Card
    </md-button>
    <md-card>
      <md-card-header
        class="md-card-header-icon"
        :class="getClass(headerColor)"
      >
        <div class="card-icon">
          <md-icon>contact_support</md-icon>
        </div>
        <h4 class="title">
          Plan Details
        </h4>
        <help-link :link="helpLink.link"></help-link>
      </md-card-header>
      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-size-100 ls-status-block">
            <dl class="descriptive-list-spaced">
              <dt>
                <label class="ls-label">Subscription Status</label>
              </dt>
              <dd>
                <badge :type="getBadgeType(subscription.status)">{{
                  getSubscriptionStatus(subscription.status)
                }}</badge>
              </dd>
              <div v-if="subscription.status !== 'cancelled'">
                <dt>
                  <label class="ls-label">Next Billing Date</label>
                </dt>
                <dd>
                  <label data-tour="next_billing_date">
                    {{ getDateFromTime(subscription.nextBillingOn) }}
                  </label>
                </dd>
              </div>
              <div v-if="subscription.status === 'in_trial'">
                <dt>
                  <label class="ls-label">Trial End Date</label>
                </dt>
                <dd>
                  <label data-tour="tiral_end_date">{{
                    getDateFromTime(subscription.trialEndOn)
                  }}</label>
                </dd>
              </div>
            </dl>
          </div>
          <div class="md-layout-item md-size-20">
            <div>
            </div>
          </div>
          <div class="md-layout-item md-size-80 add-flex text-right">
            <a
              class="md-danger md-sm ls-float-right flex-end"
              href="mailto:sales@liveswitch.io"
              rel="nofollow noopener"
            >
              To change your subscription, contact Sales.
            </a>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </form>
</template>
<script>
import { Badge } from "@/components";
import api from "@/api";
import { HelpLinkTemplate } from "@/fmComponents";
import helpLinks from "../../contextualHelpLinks.js";
export default {
  components: {
    Badge,
    "help-link": HelpLinkTemplate,
  },
  props: {
    headerColor: {
      type: String,
      default: ""
    },
    subscription: {}
  },
  data() {
    return {
      config: api.props.config,
      helpLink: helpLinks.subscription
    };
  },
  mounted() {
    let hubScript = document.createElement("script");
    hubScript.setAttribute("src", "https://js.hscta.net/cta/current.js");
    hubScript.addEventListener("load", this.hubSpotLoad);
    document.head.appendChild(hubScript);
  },
  methods: {
    getClass: function(headerColor) {
      return "md-card-header-" + headerColor + "";
    },
    hubSpotLoad: function() {
      //true if we are on dev or prod
      if (
        this.config.environment === "nightly" ||
        this.config.environment === "rc" ||
        this.config.environment === "prod"
      ) {
        //will have to figure out which CTA to load here based on the current subscription and our environment
        var hubSpotId = 3919779;
        var hubSpotGuid = "";
        if (this.subscription.status === "active") {
          //change support CTA
          if (this.config.environment === "nightly") {
            hubSpotGuid = "4a07c762-5efd-4cf7-9ba5-debaa9c6642b";
          } else {
            hubSpotGuid = "a3e80394-e71f-45f0-bebd-de2ed33e93a8";
          }
        } else if (
          this.subscription.status === "cancelled" &&
          !this.subscription.platformPlan.name.includes("TRIAL") &&
          this.subscription.cancelledReason !== "no_card"
        ) {
          // reactivate CTA
          if (this.config.environment === "nightly") {
            hubSpotGuid = "744b7737-650a-4df4-88c0-bd248679951c";
          } else {
            hubSpotGuid = "3977421a-2a76-4406-84ae-9bd81427bb16";
          }
        } else if (
          this.subscription.status === "cancelled" &&
          this.subscription.cancelledReason === "no_card"
        ) {
          return "";
        }
        // eslint-disable-next-line
        hbspt.cta.load(hubSpotId, hubSpotGuid, {});
      }
    },
    getBadgeType: function(status) {
      switch (status) {
        case "in_trial":
          return "info";
        case "active":
          return "primary";
        case "cancelled":
          return "danger";
        default:
          return "info";
      }
    },
    getSubscriptionStatus: function(status) {
      switch (status) {
        case "future":
          return "Future";
        case "in_trial":
          return "In Trial";
        case "active":
          return "Active";
        case "paused":
          return "Paused";
        case "cancelled":
          return "Cancelled";
        default:
          return "Unknown";
      }
    },
    getDateFromTime: function (time) {
      var d = new Date(0); // The 0 there is the key, which sets the date to the epoch
      d.setUTCSeconds(time);
      return d.toDateString();
    }
  }
};
</script>
<style type="scss" scoped>
.ls-date-label {
  margin-bottom: -15px;
}
.add-flex {
  display: flex;
}
.flex-end {
  align-self: flex-end;
}
.descriptive-list-spaced {
  line-height: 2.3em;
}
.descriptive-list-spaced dt {
  display: inline-block;
  width: 12em;
}
.descriptive-list-spaced dd {
  display: inline-block;
}

@media screen and (min-width: 431px) {
  h4.title {
    display: inline-flex;
  }
  .contextual-help {
    display: inline-flex;
    float: right;
    margin-top: 20px;
  }
  /deep/ .contextual-help > a {
    padding-top: 2px;
  }
}
</style>
